import store from "@/store";
import Financial from "./store";
export default [
  {
    path: "/financial",
    name: "financial",
    redirect: "/financial/financial-data",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("Financial"))
        store.registerModule("Financial", Financial);
      next();
    },
    children: [
      {
        path: "financial-data",
        name: "financial-data",
        component: () => import("./pages/financial-data/index.vue"),
        meta: {
          pageTitle: "البيانات المالية ",
          slug: "ngo_financial_info",
          instructionsSlug: "ngo_financial_info",
          breadcrumb: [
            {
              text: "البيانات المالية",
              active: true,
            },
          ],
        },
      },
      {
        path: "financial-grant",
        name: "financial-grant",
        component: () => import("./pages/financial-grant/index.vue"),
        meta: {
          pageTitle: "طلبات المنحة المالية ",
          slug: "ngo_financial_grants",
          instructionsSlug: "ngo_financial_grants",
          breadcrumb: [
            {
              text: "طلبات المنحة المالية",
              active: true,
            },
          ],
        },
      },
      {
        path: "money-transferred-abroad",
        name: "money-transferred-abroad",
        component: () => import("./pages/money-transferred-abroad/index.vue"),
        meta: {
          pageTitle: "الأموال المُحولة للخارج",
          slug: "ngo_money_transferred_abroad",
          instructionsSlug: "ngo_money_transferred_abroad",
          breadcrumb: [
            {
              text: "الأموال المُحولة للخارج",
              active: true,
            },
          ],
        },
      },
      {
        path: "international-Donations",
        name: "international-Donations",
        component: () => import("./pages/international-Donations/index.vue"),
        meta: {
          pageTitle: "التبرعات الخارجية",
          slug: "ngo_international_donations",
          instructionsSlug: "ngo_international_donations",
          breadcrumb: [
            {
              text: "التبرعات الخارجية",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
